import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getBranches, updateUserBranch } from "../../api/admin/branch";
import "./BranchSelectionModal.css";

const BranchSelectionModal = ({ onComplete }) => {
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    getBranches()
      .then(({ data }) => setBranches(data?.result || []))
      .catch(() => toast.error("Failed to load branches. Please refresh."))
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedBranch) {
      toast.error("Please select a branch to continue.");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await updateUserBranch(selectedBranch);
      // Sync the updated user (with branch) into storage
      const authData = JSON.parse(localStorage.getItem("authData") || "null");
      if (authData && data.user) {
        authData.user = data.user;
        localStorage.setItem("authData", JSON.stringify(authData));
        sessionStorage.setItem("user", JSON.stringify(data.user));
      }
      toast.success("Branch assigned successfully!");
      onComplete();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to assign branch.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bsm-overlay">
      <div className="bsm-card">
        <div className="bsm-icon">🏥</div>
        <h2 className="bsm-title">Select Your Branch</h2>
        <p className="bsm-subtitle">
          Your account has no branch assigned yet. Please choose the branch you
          belong to before continuing.
        </p>

        <form onSubmit={handleSubmit} className="bsm-form">
          {loading ? (
            <div className="bsm-skeleton" />
          ) : (
            <select
              className="bsm-select"
              value={selectedBranch}
              onChange={(e) => setSelectedBranch(e.target.value)}
              required
            >
              <option value="" disabled>
                — Choose a branch —
              </option>
              {branches.map((b) => (
                <option key={b._id} value={b._id}>
                  {b.name}
                  {b.address ? ` — ${b.address}` : ""}
                </option>
              ))}
            </select>
          )}

          <button
            type="submit"
            className="bsm-btn"
            disabled={submitting || loading || !selectedBranch}
          >
            {submitting ? "Saving…" : "Confirm Branch"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BranchSelectionModal;
